import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { homePricing } from "./homeData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PRICE_KEYS = { starter: "plan_starter_price", pro: "plan_pro_price", premium: "plan_premium_price" };

export function usePricingCheckout(settings, user) {
  const navigate = useNavigate();
  const [checkoutLoading, setCheckoutLoading] = useState("");
  const [checkoutError, setCheckoutError] = useState("");

  const dynamicPricing = homePricing.map((p) => {
    const key = PRICE_KEYS[p.id] || "plan_premium_price";
    return { ...p, price: `£${settings[key] || settings.plan_firm_price || p.price.replace("£", "")}` };
  });

  const startCheckout = async (planId) => {
    setCheckoutError("");
    if (!user) {
      navigate("/register", { state: { plan: planId } });
      return;
    }
    setCheckoutLoading(planId);
    try {
      const { data } = await axios.post(`${API}/billing/checkout`, {
        plan: planId,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (err) {
      setCheckoutError(err?.response?.data?.detail || "Could not start checkout. Please try again.");
      setCheckoutLoading("");
    }
  };

  return { dynamicPricing, startCheckout, checkoutLoading, checkoutError };
}
